import { http } from '../../../resources/http';
import {
    SupplierAndStockLocationWithPreferenceDTO,
    SupplierPreference,
    SupplierTag,
} from '../../../resources/supplierAndStockLocation/supplierAndStockLocationBackendTypes';

// TODO: This function doesn't return an approved supplier and stock location - it is just the first OTS supplier and stock location
export async function getFirstOTSApprovedSupplierAndStockLocation(
    token: string,
): Promise<SupplierAndStockLocationWithPreferenceDTO> {
    const suppliers = await http('GET /suppliers-and-stock-locations', {}, token);
    const supplierAndStockLocation = suppliers.data.find((s) =>
        s.tags.some((tag) => tag.tag === SupplierTag.OffTheShelfPartSupplier),
    );
    if (!supplierAndStockLocation) {
        throw new Error('No approved suppliers found in organization');
    }

    return {
        ...supplierAndStockLocation,
        preference: SupplierPreference.Approved,
    };
}
